import styled from 'styled-components';
import { Adornment, spaceMixin } from '@zillow/constellation';

export const StyledTimeInputAdornment = styled(Adornment)`
  padding-left: ${spaceMixin('xs')};
  padding-right: ${spaceMixin('xs')};
`;
